import axios from 'axios'
import VueAxios from 'vue-axios'
var _ = require('lodash');
import store from './store'

// let client = JSON.parse(localStorage.getItem('client'));
// var api_token = !_.isEmpty(client) ? client.api_token : store.getters.apiToken;
var api_token = store.getters.apiToken;
export default() => {
    return axios.create({
        baseURL:process.env.VUE_APP_API_URL,// `http://localhost:8001/api/v1/user`, // base url
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
           'Authorization': `Bearer ${api_token}`
        },
        params: {
            conference_id: process.env.VUE_APP_CONFERENCE_ID, // define conference_id from ems database
            // api_token: api_token
        }
    })
}

export {axios, VueAxios}
